import { IS_PRINT_LOG } from "../network/config/ApiConfig";

export function consoleLog(key,value){
    if (IS_PRINT_LOG){
        console.log(key,value);
    }   
}